import React, { useContext, useEffect, useState } from "react";
import UserContext from "../context/UserContext";
import { SERVER_IP, ud, jwt } from "../Server";
import Swal from "sweetalert2";
import axios from "axios";
import { CloseIcon } from "../assets/Icons";

export default function FAQEdit(props) {
  const { faq_id, faq_title, faq_description } = props;
  const context = useContext(UserContext);
  const { updateddata, setUpdateddata } = context;

  const [inputdata, setInputdata] = useState({ title: "", description: "" });
  const onChange = (e) => {
    setInputdata({ ...inputdata, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setInputdata({ title: faq_title, description: faq_description });
  }, []);

  const clickHandler = async (e) => {
    e.preventDefault();
    var data = { faq_id, title: inputdata.title, description: inputdata.description };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    const result = await axios.post(`${SERVER_IP}/userfaq/edit`, data, { withCredentials: true, headers: headers });
    if (result.data.error === false) {
      updateddata ? setUpdateddata(false) : setUpdateddata(true);
      document.getElementById(`editModal${faq_id}`).click();
      Swal.fire({
        title: "Successfully edited",
        text: result.msg,
        icon: "success",
        confirmButtonText: "Ok",
      });
    } else {
      document.getElementById(`editModal${faq_id}`).click();
      Swal.fire({
        title: "Error",
        text: result.msg,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <>
      <div className="modal-dialog modal-lg" role="document" key={faq_id}>
        <div className="modal-content">
          <div className="modal-header py-3 d-flex align-items-center bg-light border-radius-top-15">
            <h5 className="modal-title" id="editModalLabel">
              Edit FAQ
            </h5>
            <button id={`editModal${faq_id}`} type="button" className="close-s" data-dismiss="modal">
              <CloseIcon />
            </button>
          </div>

          <div className="container mb-3">
            <div className="row">
              <form className="col-sm-12 mt-3">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="form-group">
                      <label htmlFor="Title">Title:</label>
                      <input
                        id="title"
                        type="text"
                        placeholder="Title:"
                        className="form-control mb-2"
                        name="title"
                        value={inputdata.title}
                        onChange={onChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="Description">Description:</label>
                      <textarea
                        id="description"
                        placeholder="Description..."
                        className="form-control"
                        rows="3"
                        name="description"
                        value={inputdata.description}
                        onChange={onChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="px-3">
                  <button type="submit" className="btn btn-primary mr-4" onClick={clickHandler}>
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
